// app_client/src/components/providers/ErrorProvider.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import axios from 'axios';
import useAuthStore from '../../store/authStore';

const getErrorMessage = (error) => (
  error.response?.data?.message ||
  error.response?.data?.error ||
  'Sunucuyla iletişim sırasında bir hata oluştu.'
);

const ErrorProvider = ({ children }) => {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);

  useEffect(() => {
    const interceptorId = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error.response?.status;
        const code = error.response?.data?.code;

        if (status === 401 || code === 'USER_PASSIVE') {
          logout();

          if (window.location.pathname !== '/login') {
            navigate('/login', { replace: true });
          }
        } else if (status === 400 || status >= 500) {
          const errorMessage = getErrorMessage(error);
          toast.error(errorMessage, { duration: 6000 });
          console.error("Detaylı Hata:", error);
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptorId);
    };
  }, [logout, navigate]);

  return children;
};

export default ErrorProvider;
